import ReportEntryTotal from './ReportEntryTotal'

export default ReportEntryTotal
